<template>
    <v-container fluid>
        <v-toolbar flat color="white">
            <!--Employee FORM-->
            <template v-if="type === 'form'">
                <v-toolbar-title >{{ formTitle }} </v-toolbar-title>
            </template>
            <!--Employee VIEW TABLE-->
            <template v-if="type === 'view'">
                <v-toolbar-title>Document Rules Table</v-toolbar-title>
                <v-spacer></v-spacer>
                <responsiveButton setTo="/orgWorkSpace/document-rule/add/document"
                                  setColor="blue"
                                  setDefaultIcon="mdi-plus"
                                  setSmallIcon="mdi-plus-circle-outline"
                >
                    Add Document Rule
                </responsiveButton>
            </template>
        </v-toolbar>
        <v-divider class="my-0 mx-6"></v-divider>
    </v-container>
</template>

<script>
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');

    export default {
        name: "DocumentRuleHeader",
        components:{responsiveButton},
        props:["hType", "tId", "dtype"],
        data(){
            return{
                type: this.hType,
                id: null
            }
        },
        watch:{
            hType(value){
                this.type = value;
            },
            tId(value){
                this.id = value;
            }
        },
        computed:{
            formTitle () {
                return this.id? 'Clone document rule' : 'New document rule';
            },
        }
    }
</script>

<style scoped>

</style>